import React from "react";
import "./TextEffect.css";

interface TextEffectProps {
  text?: string;
  textt?:  string;
  text1?: string;
  part?: string;
  text2?: string;
  part1?: string;
  part2?: string;
  part3?: string;
  part5?: string;
  text3?: string;
  text4?: string;
  part4?: string;
  className?: string;
  size?: string; // Default size (non-responsive fallback)
  responsiveSize?: string; // Tailwind responsive sizing like 'text-4xl md:text-6xl lg:text-8xl'
}

const TextEffect: React.FC<TextEffectProps> = ({
  text,
  textt,
  text1,
  text2,
  part,
  part1,
  part2,
  part3,
  text3,
  text4,
  part5,
  part4,
  className = "",
  size = "text-8xl",
  responsiveSize = "text-4xl sm:text-5xl md:text-6xl lg:text-8xl  sm:text-[12px] md:text-[18px]", // default responsive sizing
}) => {
  const appliedSize = `${size} ${responsiveSize}`;

  if (text) {
    return (
      <span className={`text-effect-white font-extrabold ${appliedSize} ${className}`}>
        {text}
      </span>
    );
  }

  return (
    <span className={`font-extrabold ${appliedSize} ${className}`}>
      {part1 && <span className={`text-effect-orange ${appliedSize}`}>{part1}</span>}
      {part2 && <span className={`text-effect-green ${appliedSize}`}>{part2}</span>}
      {text1 && <span className={`text-effect-small-white ${appliedSize}`}>{text1}</span>}
      {textt && <span className={`text-effect-small-white1 ${appliedSize}`}>{textt}</span>}
      {text2 && <span className={`text-effect-small-green ${appliedSize}`}>{text2}</span>}
      {part && <span className={`text-effect-small-orange ${appliedSize}`}>{part}</span>}
      {text && <span className={`text-effect-white ${appliedSize}`}>{text}</span>}
      {text3 && <span className={`text-effect-small-head-green ${appliedSize}`}>{text3}</span>}
      {text4 && <span className={`text-effect-small-training-white ${appliedSize}`}>{text4}</span>}
      {part4 && <span className={`text-effect-small-training-green ${appliedSize}`}>{part4}</span>}
      {part3 && <span className={`text-effect-green-header ${appliedSize}`}>{part3}</span>} 
      {part5 && <span className={`text-effect-black ${appliedSize}`}>{part5}</span>} 
    </span>
  );
};

export default TextEffect;
